import texts from './categories.texts'

class CategoriesController {
    constructor($scope, $state, $stateParams, Category) {
        this.name = 'categories'

        this.$scope = $scope
        this.$state = $state
        this.$stateParams = $stateParams
        this.Category = Category

        this.selectedCategories = []
        this.dropdownActive = false
        this.initMobileCategoriesPopup.bind(this)
    }

    $onInit () {
        this.render()
        this.selectselectedCategories()

        this.watchCategories()
        this.watchLanguage()
    }

    initMobileCategoriesPopup () {

        $('.options-background').mouseup((e) => {
            const options = $('.options')
            // if the target of the click isn't the container nor a descendant of the container
            if (
                (!options.is(e.target) && options.has(e.target).length === 0)
            ) {
                this.dropdownActive = false
                this.$scope.$apply()
            }
        })
    }

    toggleDropdown () {
        this.dropdownActive = !this.dropdownActive
        if (this.dropdownActive) {
            setTimeout(() => {
                this.initMobileCategoriesPopup()
            }, 10)
        }
    }

    render () {
        this.language = localStorage.getItem('tourists_lang') || 'EN'
        const langTexts = texts[this.language]

        const {
            All,
            CHOOSE_CATEGORY,
            CLEAR_FILTER
        } = langTexts

        this.categories = this.Category.getCategories().map(item => langTexts[item])
        this.all = All
        this.chooseCategory = CHOOSE_CATEGORY
        this.clearFilter = CLEAR_FILTER
    }

    selectselectedCategories () {
        try {
            const selectedCategories = JSON.parse(sessionStorage.getItem('tourists_categories'))

            this.selectedCategories = selectedCategories || []
            this.Category.setSelectedCategories(this.selectedCategories)
        } catch (e) {
            this.Category.setSelectedCategories([])
            this.selectedCategories = []
        }
    }

    isActive (category) {
        const langCategory = texts[this.language][category]

        return this.selectedCategories.includes(langCategory)
    }

    toggleCategory (newCategory) {
        // this.dropdownActive = false

        const category = texts[this.language][newCategory]

        if (this.selectedCategories.includes(category)) {
            this.selectedCategories = this.selectedCategories.filter(item => item !== category)
        } else {
            this.selectedCategories.push(category)
        }

        this.Category.setSelectedCategories(this.selectedCategories)

        this.clearSearches()
    }

    clearCategories () {
        this.dropdownActive = false

        this.Category.clearSelectedCategories()
        this.clearSearches()
    }

    clearSearches () {
        if (this.$stateParams.search) {
            this.$state.go('home', {
                search: ''
            })
        }
    }

    watchCategories () {
        this.$scope.$watch(() => this.Category.getSelectedCategories(), (newValue) => {
            this.selectedCategories = newValue
        })
    }

    watchLanguage () {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }
}

CategoriesController.$inject = ['$scope', '$state', '$stateParams', 'Category']

export default CategoriesController



// WEBPACK FOOTER //
// ./client/app/components/home/sidebar/categories/categories.controller.js